/**
 * Restaurant/cafe/mart register form leftover UI — tuples [ko, en, vi, ru].
 */

function pick(map, langIndex) {
  const out = {};
  Object.entries(map).forEach(([k, v]) => {
    if (Array.isArray(v) && v.length >= 4) out[k] = v[langIndex];
    else if (v && typeof v === 'object' && !Array.isArray(v)) out[k] = pick(v, langIndex);
    else out[k] = v;
  });
  return out;
}

const register = {
  titleCafe: ['카페 등록', 'Register cafe', 'Đăng ký quán cà phê', 'Регистрация кафе'],
  titleMart: ['마트 등록', 'Register mart', 'Đăng ký siêu thị', 'Регистрация магазина'],
  titleRestaurant: ['식당 등록', 'Register restaurant', 'Đăng ký nhà hàng', 'Регистрация ресторана'],
  titleBiz: ['업체 등록', 'Register business', 'Đăng ký cửa hàng', 'Регистрация заведения'],
  entityCafe: ['카페', 'Cafe', 'Quán cà phê', 'Кафе'],
  entityMart: ['마트', 'Mart', 'Siêu thị', 'Магазин'],
  entityRestaurant: ['식당', 'Restaurant', 'Nhà hàng', 'Ресторан'],
  entityBiz: ['업체', 'Business', 'Cửa hàng', 'Заведение'],
  editTitle: ['업체 정보 수정', 'Edit business', 'Sửa thông tin cửa hàng', 'Изменить заведение'],
  stepLine: ['{entity} 등록 단계 {step}/7', '{entity} · step {step}/7', '{entity} · bước {step}/7', '{entity} · шаг {step}/7'],
  stepLineEdit: ['업체 수정 단계 {step}/7', 'Edit · step {step}/7', 'Sửa · bước {step}/7', 'Правка · шаг {step}/7'],
  deprecateBefore: ['이 폼은 곧 단계적 종료됩니다.', 'This form will be retired.', 'Form này sẽ sớm ngừng.', 'Эта форма будет отключена.'],
  deprecateCta: ['30초 빠른 등록', '30-second quick register', 'Đăng ký nhanh 30 giây', 'Быстрая регистрация за 30 сек'],
  deprecateAfter: ['을 권장해요.', 'is recommended.', 'được khuyến nghị.', 'рекомендуется.'],
  loadingEdit: ['업체 정보 불러오는 중…', 'Loading business…', 'Đang tải cửa hàng…', 'Загрузка заведения…'],
  maxThree: ['최대 3개까지 선택할 수 있어요', 'You can pick up to 3', 'Chọn tối đa 3', 'Можно выбрать до 3'],
  primary: ['주', 'Main', 'Chính', 'Осн.'],
  secondary: ['부', 'Sub', 'Phụ', 'Доп.'],
  primaryHelpAria: ['주 카테고리 안내', 'About main category', 'Về danh mục chính', 'О основной категории'],
  primaryHelp: [
    '주 카테고리를 변경하려면 현재 선택된 주 카테고리를 먼저 해제하고 새로운 카테고리를 첫 번째로 선택하세요',
    'To change the main category, unselect it first, then pick a new one as the first choice',
    'Để đổi danh mục chính, bỏ chọn hiện tại rồi chọn danh mục mới trước',
    'Чтобы сменить основную категорию, снимите её и выберите новую первой',
  ],
  typeMax3: ['업종 선택 (최대 3개)', 'Business type (up to 3)', 'Loại hình (tối đa 3)', 'Тип (до 3)'],
  detailTags: ['세부 태그', 'Detail tags', 'Thẻ chi tiết', 'Теги'],
  customTagsHint: [
    '선택: 엔터로 직접 태그 추가 (최대 20개)',
    'Optional: custom tags with Enter (max 20)',
    'Tuỳ chọn: thêm thẻ bằng Enter (tối đa 20)',
    'Дополнительно: свои теги через Enter (до 20)',
  ],
  customTagsPh: ['예: 배달, 한국어메뉴', 'e.g. delivery, Korean menu', 'vd: giao hàng, menu tiếng Hàn', 'напр. доставка, корейское меню'],
  gpsTitle: ['업체 위치 (GPS)', 'Location (GPS)', 'Vị trí (GPS)', 'Место (GPS)'],
  latPh: ['위도 (예: 16.0544)', 'Latitude (e.g. 16.0544)', 'Vĩ độ (vd: 16.0544)', 'Широта (напр. 16.0544)'],
  lngPh: ['경도 (예: 108.2022)', 'Longitude (e.g. 108.2022)', 'Kinh độ (vd: 108.2022)', 'Долгота (напр. 108.2022)'],
  mapLater: ['나중에 지도 핀으로 교체 예정', 'Map pin coming later', 'Sẽ thay bằng ghim bản đồ', 'Позже заменим меткой на карте'],
  priceBand: ['가격대', 'Price range', 'Mức giá', 'Ценовой диапазон'],
  currency: ['통화', 'Currency', 'Tiền tệ', 'Валюта'],
  open24Check: [
    '24시간 영업 — 체크하면 아래 시간 선택 없이 등록됩니다',
    'Open 24 hours — skip hours below if checked',
    'Mở 24 giờ — bỏ chọn giờ bên dưới nếu đánh dấu',
    'Круглосуточно — часы ниже не нужны, если отмечено',
  ],
  amenities: ['편의시설', 'Amenities', 'Tiện ích', 'Удобства'],
  languages: ['언어 지원', 'Languages', 'Ngôn ngữ', 'Языки'],
  menuPriceHint: [
    '메뉴 가격은 선택 사항입니다 · 통화: {sym} ({code})',
    'Menu prices are optional · currency: {sym} ({code})',
    'Giá món là tuỳ chọn · tiền tệ: {sym} ({code})',
    'Цены меню необязательны · валюта: {sym} ({code})',
  ],
  optional: ['(선택)', '(optional)', '(tuỳ chọn)', '(необяз.)'],
  pricePh: ['예: {n} {sym}', 'e.g. {n} {sym}', 'vd: {n} {sym}', 'напр. {n} {sym}'],
  menuPhoto: ['메뉴 사진', 'Menu photo', 'Ảnh món', 'Фото меню'],
  tapAddPhoto: ['탭하여 사진 추가', 'Tap to add photo', 'Chạm để thêm ảnh', 'Нажмите, чтобы добавить фото'],
  deletePhoto: ['사진 삭제', 'Remove photo', 'Xóa ảnh', 'Удалить фото'],
  photos: ['사진', 'Photos', 'Ảnh', 'Фото'],
  photosHint: [
    '업체 사진을 등록하면 더 많은 고객이 방문해요',
    'Photos help more customers visit',
    'Ảnh giúp nhiều khách ghé hơn',
    'Фото привлекают больше гостей',
  ],
  remove: ['삭제', 'Remove', 'Xóa', 'Удалить'],
  contact: ['연락처', 'Contact', 'Liên hệ', 'Контакты'],
  zaloPh: ['Zalo 번호', 'Zalo number', 'Số Zalo', 'Номер Zalo'],
  reviewHint: ['아래 내용을 확인하고 등록을 완료하세요', 'Review below and finish registration', 'Xem lại rồi hoàn tất đăng ký', 'Проверьте и завершите регистрацию'],
  reviewType: ['식당 유형', 'Cuisine type', 'Loại món', 'Тип кухни'],
  reviewName: ['식당명', 'Name', 'Tên', 'Название'],
  reviewAddress: ['주소', 'Address', 'Địa chỉ', 'Адрес'],
  reviewHours: ['영업시간', 'Hours', 'Giờ mở', 'Часы'],
  hours24: ['24시간', '24 hours', '24 giờ', '24 часа'],
  hoursWeekday: ['평일 {a}~{b}', 'Weekdays {a}–{b}', 'Ngày thường {a}–{b}', 'Будни {a}–{b}'],
  hoursWeekend: ['주말 {a}~{b}', 'Weekend {a}–{b}', 'Cuối tuần {a}–{b}', 'Выходные {a}–{b}'],
  hoursClosed: ['휴무 {days}', 'Closed {days}', 'Nghỉ {days}', 'Выходной {days}'],
  hoursStoredWeekday: ['{a}-{b} (주중)', '{a}-{b} (weekdays)', '{a}-{b} (ngày thường)', '{a}-{b} (будни)'],
  hoursStoredWeekend: ['{a}-{b} (주말)', '{a}-{b} (weekend)', '{a}-{b} (cuối tuần)', '{a}-{b} (выходные)'],
  reviewAmenityLang: ['편의시설·언어', 'Amenities & languages', 'Tiện ích và ngôn ngữ', 'Удобства и языки'],
  reviewPhotoContact: ['사진·연락처', 'Photos & contact', 'Ảnh và liên hệ', 'Фото и контакты'],
  photoCount: ['{n}장', '{n} photos', '{n} ảnh', '{n} фото'],
  edit: ['수정', 'Edit', 'Sửa', 'Изменить'],
  menuSection: ['메뉴', 'Menu', 'Thực đơn', 'Меню'],
  menuCount: ['{n}개 등록됨', '{n} items', '{n} món', '{n} позиций'],
  afterNote: [
    '등록 후 밍고 운영팀 검토(최대 24시간)가 완료되면 업체가 노출됩니다.',
    'After you submit, Mingo reviews within 24 hours before the listing goes live.',
    'Sau khi gửi, Mingo duyệt trong 24 giờ rồi mới hiện.',
    'После отправки Mingo проверяет до 24 часов, затем публикация.',
  ],
  falseNote: [
    '허위 정보 등록 시 승인이 거절될 수 있습니다.',
    'False information may be rejected.',
    'Thông tin sai có thể bị từ chối.',
    'Ложные данные могут отклонить.',
  ],
  submit: ['등록 완료', 'Submit', 'Hoàn tất', 'Отправить'],
  save: ['저장', 'Save', 'Lưu', 'Сохранить'],
  dayMon: ['월', 'Mon', 'T2', 'Пн'],
  dayTue: ['화', 'Tue', 'T3', 'Вт'],
  dayWed: ['수', 'Wed', 'T4', 'Ср'],
  dayThu: ['목', 'Thu', 'T5', 'Чт'],
  dayFri: ['금', 'Fri', 'T6', 'Пт'],
  daySat: ['토', 'Sat', 'T7', 'Сб'],
  daySun: ['일', 'Sun', 'CN', 'Вс'],
  closedDaysHint: ['해당 요일을 모두 선택할 수 있어요', 'You can select every closed day', 'Có thể chọn mọi ngày nghỉ', 'Можно отметить все выходные дни'],
  hoursStart: ['{label} 시작', '{label} start', '{label} bắt đầu', '{label} начало'],
  hoursEnd: ['{label} 종료', '{label} end', '{label} kết thúc', '{label} конец'],
  weekdayHours: ['평일', 'Weekdays', 'Ngày thường', 'Будни'],
  weekendHours: ['주말', 'Weekend', 'Cuối tuần', 'Выходные'],
  dupTitle: ['이미 등록된 업체입니다', 'This business is already registered', 'Cửa hàng đã được đăng ký', 'Заведение уже зарегистрировано'],
  dupPhone: ['동일한 전화번호', 'the same phone number', 'cùng số điện thoại', 'тот же телефон'],
  dupNameCity: ['동일한 업체명·지역', 'the same name and area', 'cùng tên và khu vực', 'то же имя и район'],
  dupBody: ['{reason}로 등록된 업체가 있습니다.', 'A listing already exists for {reason}.', 'Đã có cửa hàng với {reason}.', 'Уже есть заведение с {reason}.'],
  dupLink: ['내 업체로 연결하기', 'Link as my business', 'Gắn với cửa hàng của tôi', 'Привязать как моё'],
  dupContinue: ['계속 등록하기', 'Continue anyway', 'Tiếp tục đăng ký', 'Продолжить'],
  deliveryInfo: ['배달 정보', 'Delivery', 'Giao hàng', 'Доставка'],
  deliveryRange: ['배달 범위', 'Delivery radius', 'Phạm vi giao', 'Радиус доставки'],
  rangeAll: ['전체', 'All', 'Tất cả', 'Все'],
  minOrder: ['최소 주문 금액', 'Min. order', 'Đơn tối thiểu', 'Мин. заказ'],
  deliveryFee: ['배달비', 'Delivery fee', 'Phí giao', 'Доставка'],
  deliveryEta: ['배달 소요시간', 'Delivery time', 'Thời gian giao', 'Время доставки'],
  eta15: ['15분', '15 min', '15 phút', '15 мин'],
  eta30: ['30분', '30 min', '30 phút', '30 мин'],
  eta45: ['45분', '45 min', '45 phút', '45 мин'],
  eta60: ['60분+', '60+ min', '60+ phút', '60+ мин'],
  amenityPet: ['반려동물', 'Pets', 'Thú cưng', 'Питомцы'],
  amenityKidsPlay: ['유아 놀이시설', 'Kids play area', 'Khu vui chơi trẻ', 'Детская площадка'],
  amenityKidsSeat: ['아기 의자·식탁', 'High chair', 'Ghế trẻ em', 'Детский стул'],
  amenityStroller: ['보행기 가능', 'Stroller OK', 'Xe đẩy OK', 'Коляски OK'],
  photoExterior: ['외관 사진', 'Exterior', 'Ngoại thất', 'Фасад'],
  photoInterior: ['내부/인테리어', 'Interior', 'Nội thất', 'Интерьер'],
  photoFood: ['음식 사진', 'Food photos', 'Ảnh món', 'Фото блюд'],
  photoMenuBoard: ['메뉴판', 'Menu board', 'Bảng menu', 'Меню-борд'],
};

const hub = {
  filterKorean: ['🇰🇷 한국어', '🇰🇷 Korean menu', '🇰🇷 Tiếng Hàn', '🇰🇷 Корейский'],
};

function buildLang(i) {
  return {
    restaurant: { register: pick(register, i) },
    foodMartHub: pick(hub, i),
  };
}

export const phaseRestaurantRegisterKo = buildLang(0);
export const phaseRestaurantRegisterEn = buildLang(1);
export const phaseRestaurantRegisterVi = buildLang(2);
export const phaseRestaurantRegisterRu = buildLang(3);
